import { Component, OnInit, ElementRef, ViewChild, NgZone, ChangeDetectorRef, DestroyRef, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { AbstractControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Storage, ref, uploadBytesResumable, getDownloadURL } from '@angular/fire/storage';
import { ApiService } from 'src/app/services/api.service';
import { HttpClient } from '@angular/common/http';
import { Observable, interval, Subscription } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';

// Custom RxJS operator for change detection
function detectChanges(cdr: ChangeDetectorRef) {
  return <T>(source: Observable<T>) => source.pipe(
    tap(() => cdr.detectChanges())
  );
}
import { FileDownloadService } from '../../services/filedownload.service';
import { VisitorServiceService } from 'src/app/services/visitor-service.service';
import { HelperService } from '../../services/helper.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { NgOtpInputModule } from 'ng-otp-input';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormatFileSizePipe } from '../../format-file-size.pipe';
import { FooterComponent } from '../footer/footer.component';
import * as fileSaver from 'file-saver';
import * as JSZip from 'jszip';
declare var $: any;
@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    NgOtpInputModule,
    NgbModule,
    FormatFileSizePipe,
    FooterComponent
  ],
  providers: [DatePipe]
})
export class UploadComponent implements OnInit {

  @ViewChild('fileInput') fileInput!: ElementRef;

  lanName: any = '';

  getLang: any = localStorage.getItem('net_lang_new');
  userData: any = '';
  remainStorageCapacity: any = '';
  totalStorageCapacity: any = '';
  usedStorageCapacity: any = '';
  currentUrl: string = '';
  currentUser: any = '';
  currentUserUid: any = '';
  memberID: any = '';
  LogoUrl: any = '';
  companyName: any = '';
  companyOwnWebsite: any = '';
  borderTopColor: any = '';
  borderBottomColor: any = '';
  buttonBGselectedColor: any = '';
  buttonTextselectedColor: any = '';

  sendOtpForm!: FormGroup;
  sendOtpFormSubmitted = false;
  sendEmailOTP: boolean = false; //false

  composeFormVisible: boolean = false; //false
  EmailDownloadCode: string = '';
  EmailDownloadCodeVerify: boolean = false;
  EmailOtpWrongAttempts: number = 0;
  isEmailOtpBlocked: boolean = false;
  readonly maxEmailOtpAttempts = 3;

  /** 5-minute countdown for the OTP's validity. */
  readonly emailOtpDurationSeconds = 5 * 60;
  emailOtpTimeLeft = this.emailOtpDurationSeconds;
  emailOtpExpired = false;
  private emailOtpTimerSub?: Subscription;

  EmailConfig = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '74px',
      'height': '107px',
      'font-size': '28px',
      'color': '#2196f3',
      'font-weight': '600',
      'border-radius': '8px'
    }
  };


  composeForm!: FormGroup;
  submitted = false;

  fileList: any = [];
  fileName = '';
  listOfFiles: any[] = [];

  uploads: any[] = [];
  percentage = 0;
  uploadStart: boolean = false;

  uploadProgress!: Observable<any>;
  uploadState!: Observable<any>;
  downloadURL!: string;
  selectedFile: any;
  totalFileCount!: number;
  totalFilesSize: number = 0;
  allPercentage!: Observable<any>;
  download_code: any = '';

  fileDownloadUrls: any[] = [];

  ipaddress: string = '';
  city: string = '';
  country: string = '';
  state: string = '';

  operationLogFileStrings: any[] = [];

  freelancerUid: any = '';

  // INTERNER SPEED CHECK

  InternetSpeed: any = 0;
  unit: string = "Mbps";
  remainingTimes: string[] = [];
  internetSpeed: number[] = [];
  remainingTime: string = '';

  destroyRef = inject(DestroyRef);
  share_id: any = '';
  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    public translateService: TranslateService,
    private toast: NotificationService,
    private formBuilder: FormBuilder,
    public HelperService: HelperService,
    private storage: Storage,
    private http: HttpClient,
    private titleService: Title,
    public datepipe: DatePipe,
    private apiService: ApiService,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private visitorsService: VisitorServiceService) {

    this.lanName = localStorage.getItem('net_lang_new');

    if (this.lanName == null) {
      this.lanName = 'jp';
    }
    else {
      this.lanName = localStorage.getItem('net_lang_new');
    }

    console.log('language ----------->', this.lanName);


    this.share_id = this.activatedRoute.snapshot.paramMap.get("id");
  }

  ngOnInit(): void {

    // Use window.location instead of deprecated router API
    this.currentUrl = window.location.origin;
    // console.log('currentURL:', this.currentUrl);
    var pathArray = this.currentUrl.split('.');
    var host = pathArray[0].split('//');
    // var url = host[1];
    var url = window.location.host;
    let jSon = {
      // brand_url: 'whitepointindia.net0.download',
      brand_url: url,
      share_id: this.share_id      // brand_url: url
    }
    this.getFreelancerDetails(jSon);

    this.sendOtpForm = this.formBuilder.group({
      email: [null, [Validators.required, Validators.email]]
    });


    this.composeForm = this.formBuilder.group(
      {
        message: [''],
        filesInput: [this.fileName, Validators.required]
      });


    // Fetch Location Details with fallback mechanism
    // this.fetchLocationWithFallback();
    this.getLocations();




  }

  /**
   * Fetch location using MaxMind geoip-js.com service
   * MaxMind provides IP and location details in a single API call
   */
  private fetchLocationWithFallback(): void {
    console.log('Starting location fetch...');

    // Get IP address and location in one call using MaxMind
    this.visitorsService.getIpAddress().subscribe({
      next: (geoData: any) => {
        console.log('✅ MaxMind data fetched:', geoData);

        // Extract IP address from MaxMind response
        this.ipaddress = geoData.traits?.ip_address || 'Unknown';

        // Extract location details from MaxMind response
        this.city = geoData.city?.names?.en || 'Unknown';
        this.state = geoData.subdivisions?.[0]?.names?.en || 'Unknown';
        this.country = geoData.country?.names?.en || 'Unknown';

        console.log('📍 Location:', this.city, this.state, this.country);
      },
      error: (error: any) => {
        console.error('❌ MaxMind API failed:', error);
        this.setDefaultLocationValues();
      }
    });
  }

  /**
   * Set default values when location fetch fails
   */
  private setDefaultLocationValues(): void {
    this.city = 'Not available';
    this.state = 'Not available';
    this.country = 'Not available';
    this.ipaddress = 'Not available';
    console.log('⚠️ Using default location values');
  }

  get sendOtpformReturn(): { [key: string]: AbstractControl } {
    return this.sendOtpForm.controls;
  }

  get f(): { [key: string]: AbstractControl } {
    return this.composeForm.controls;
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.composeForm.invalid) {
      return;
    }
    else {
      this.upload();

    }
  }

  upload() {
    this.composeForm.controls['message'].disable();
    this.uploadStart = true;
    this.uploads = [];
    this.fileDownloadUrls = [];
    this.operationLogFileStrings = [];
    this.remainingTimes = [];
    this.internetSpeed = [];

    const current = new Date();
    const timestamp = current.getTime();
    let fileListCount = this.fileList.length;
    let count = 0;

    // Store files to upload before clearing fileList
    const filesToUpload = [...this.fileList];
    this.fileList = [];

    for (const file of filesToUpload) {
      const path = this.currentUserUid + `/` + `_` + timestamp + `/` + file.name;
      console.log('File Upload Path:', path);
      const storageRef = ref(this.storage, path);
      const uploadTask = uploadBytesResumable(storageRef, file);

      // Create a separate Observable for each file with shareReplay to allow multiple subscriptions
      const fileUploadProgress = new Observable<number>((observer) => {
        // Emit initial 0% progress immediately
        this.ngZone.run(() => {
          observer.next(0);
        });

        uploadTask.on('state_changed',
          (snapshot) => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            // Run inside Angular zone to trigger change detection
            this.ngZone.run(() => {
              observer.next(progress);
            });
          },
          (error) => {
            this.ngZone.run(() => {
              observer.error(error);
            });
          },
          async () => {
            this.ngZone.run(async () => {
              observer.complete();
              const downloadURL = await getDownloadURL(storageRef);
              let fileJson = {
                name: file.name,
                path: downloadURL,
                size: file.size,
                type: file.type
              }
              this.fileDownloadUrls.push(fileJson);
              const operationString = this.sendOtpForm.controls['email'].value + ' が ' + file.name + ' をアップロードしました。(' + this.ipaddress + ')';
              this.operationLogFileStrings.push(operationString);

              // Check if all files are uploaded
              if (fileListCount === this.fileDownloadUrls.length) {
                let jSon = {
                  share_id: this.share_id,
                  member_id: this.memberID,
                  // member_email: this.sendOtpForm.controls['email'].value, 
                  message: this.composeForm.controls['message'].value,
                  files: this.fileDownloadUrls,
                  total_file_size: this.totalFilesSize,
                  created_on: this.datepipe.transform(new Date(), 'yyyy-MM-dd'),
                  timestamp: timestamp,
                  ipaddress: this.ipaddress,
                  city: this.city,
                  country: this.country,
                  state: this.state
                }

                console.log('Tranasfer Json ========>', JSON.stringify(jSon));
                this.apiService.sendCollections(jSon)
                  .subscribe((data: any) => {
                    console.log('collection save -------------------->', data);
                    if (data.success == 1) {
                      this.toast.showSuccess(this.translateService.instant('collection_send_successfully'), this.translateService.instant('success'));

                      this.uploads = [];
                      this.totalFilesSize = 0;
                      this.composeForm.reset();
                      this.composeForm.controls['filesInput'].setValue("");
                      this.composeForm.controls['filesInput'].setErrors({ required: false });
                      console.log(" this.composeForm ", this.composeForm);

                      // Reset the file input element
                      if (this.fileInput && this.fileInput.nativeElement) {
                        this.fileInput.nativeElement.value = '';
                      }

                      this.composeForm.controls['message'].enable();
                      this.uploadStart = false;
                      this.fileDownloadUrls = [];
                      this.remainingTimes = [];
                      this.internetSpeed = [];

                      // operation log
                      let myJson = {
                        share_id: this.share_id,
                        texted_string: this.operationLogFileStrings,
                        created_at: timestamp
                      }

                      console.log('Operation Log Array----------->', myJson);
                      this.apiService.saveOperationLogArray(myJson).subscribe({
                        next: (res: any) => {
                          if (res.success == 1) {
                            console.log('operation log data ------------------->', res);
                          }
                        },
                        error: (err: any) => {
                          console.log(err);
                        }
                      });

                      this.operationLogFileStrings = [];
                    } else {
                      this.toast.showError('', this.translateService.instant('unable_to_send_collection'));
                    }
                  });
              }
            });
          }
        );
      }).pipe(shareReplay(1));

      this.remainingTimes.push('');
      this.internetSpeed.push(0);

      const transferData = "";
      this.fileTransferTime(file, timestamp, count, fileUploadProgress);

      // Create upload tracking object for this file
      const uploadTrack = {
        fileName: file.name,
        fileSize: file.size,
        fileType: file.type,
        percentage: fileUploadProgress,
        remainingTime: transferData
      }

      // Push each upload into the array
      this.uploads.push(uploadTrack);
      count++;
    }
  }

  onFileSelected(event: any) {
    console.log("GGGGGGGGGG  ", event);
    console.log(event.target.files);

    for (var i = 0; i <= event.target.files.length - 1; i++) {
      this.selectedFile = event.target.files[i];
      const fileNameGget = this.selectedFile.name;
      const Extention = fileNameGget.substring(fileNameGget.lastIndexOf('.') + 1, fileNameGget.length);

      console.log(this.selectedFile.type);
      // Check if file name already exists in the fileList
      let isFileAlreadyAdded = this.fileList.some((file: { name: any; }) => file.name === fileNameGget);
      if (isFileAlreadyAdded) {
        this.toast.showInfoLonger('', fileNameGget + ' ' + this.translateService.instant('file_already_in_list'));
        console.log('File name already exists in the list');
        continue; // Skip adding the file and move to the next file
      }

      console.log(this.selectedFile.webkitRelativePath);
      console.log('Selected File Size---------->', event.target.files[i].size);

      console.log(Extention);

      const blacklistExtension = ['ade', 'adp', 'apk', 'appx', 'appxbundle', 'bat', 'cab', 'chm', 'cmd', 'com', 'cpl', 'diagcab', 'diagcfg', 'diagpack', 'dll', 'dmg', 'ex', 'ex_', 'exe', 'hta', 'ins', 'isp', 'jar', 'jnlp', 'js', 'jse', 'lib', 'lnk', 'mde', 'msc', 'msi', 'msix', 'msixbundle', 'msp', 'mst', 'nsh', 'pif', 'ps1', 'scr', 'sct', 'shb', 'sys', 'vb', 'vbe', 'vbs', 'vhd', 'vxd', 'wsc', 'wsf', 'wsh', 'xll', 'def'];

      if (fileNameGget.indexOf('\'') >= 0 || fileNameGget.indexOf('"') >= 0) {

        this.toast.showInfoLonger('', fileNameGget + ' ' + this.translateService.instant('unrecognized_file_name_contains'));
        console.log('Upload cannot start because the file name contains unrecognizable special characters');
      }
      else {
        if (blacklistExtension.includes(Extention)) {
          console.log('Black list ditected -----', Extention)
          this.toast.showInfoLonger('', this.translateService.instant('file_type_not_supported'));
        }
        else {

          if (this.selectedFile.size > this.remainStorageCapacity) {
            this.toast.showInfo('', this.translateService.instant('stroage_capacity_not_enough'));
          }
          else {
            // Calculate new total size if this file were added
            const newTotalSize = Number(this.totalFilesSize) + this.selectedFile.size;

            if (newTotalSize > this.remainStorageCapacity) {
              this.toast.showInfo('', this.translateService.instant('stroage_capacity_not_enough'));
              // Don't update totalFilesSize since file is not being added
            }
            else {
              // Only update totalFilesSize if file is actually added
              this.totalFilesSize = newTotalSize;
              this.fileList.push(this.selectedFile);
              console.log('File list shows here------', this.fileList);
            }
            console.log('TOTAL FILE SIZZE', this.totalFilesSize);


            this.totalFileCount = this.fileList.length;
            this.composeForm.controls['filesInput'].setValue(event.target.files[0] ? event.target.files[0].name : '');
          }
        }
      }
    }

    // Clear the file input after processing to allow selecting same files again if needed
    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  deleteConfirm(delitemid: any, delitemsize: any) {
    console.log('Delete item TOTAL FILE SIZE', this.totalFilesSize);
    this.fileList.splice(delitemid, 1);
    this.totalFileCount = this.fileList.length;
    this.totalFilesSize = (this.totalFilesSize - delitemsize);

    console.log(this.totalFileCount);
    console.log('File Delete Size', delitemsize);
    console.log('Item Deleted then total file size', this.totalFilesSize);

    if (this.totalFileCount < 1) {

      console.log('File count empty');
      this.composeForm.controls['filesInput'].setValue('');
      this.composeForm.invalid;
    } else {
      console.log('File count have');
      this.composeForm.valid;
    }
  }



  sendOtpForVerification(): void {
    this.sendOtpFormSubmitted = true;
    if (this.sendOtpForm.invalid) {
      console.log('InValid', this.sendOtpForm.controls);
      return;
    } else {

      let jSon: any = '';

      jSon = {
        share_id: this.share_id,
        member_email: this.sendOtpForm.controls['email'].value
        // lang_type : this.getLang,
      }

      this.apiService.sendMemberOTP(jSon).subscribe((res: any) => {

        console.log('SEND OTP CHECKING--------------------->', res)
        if (res.success == 0) {
          this.toast.showInfo(this.translateService.instant('not_registerd_with_freelancer'), this.translateService.instant('error'));
        }
        else {
          this.toast.showInfo(this.translateService.instant('otp_send_successfully'), this.translateService.instant('success'));
          this.memberID = res.id;
          this.sendEmailOTP = true;
          this.startEmailOtpTimer();
        }


      }, (err: any) => {
        console.log(err);
      })


      console.log(JSON.stringify(jSon));


    }
  }


  onEmailOtpChange(EmailDownloadCode: any) {
    if (EmailDownloadCode.length == 4) {
      this.EmailDownloadCode = EmailDownloadCode;
      this.EmailDownloadCodeVerify = true;
      console.log(this.EmailDownloadCodeVerify);
    }
    else {
      this.EmailDownloadCodeVerify = false;
    }
  }

  checkEmailOtp() {

    if (this.isEmailOtpBlocked || this.emailOtpExpired) {
      return;
    }

    let jSon = {
      member_email: this.sendOtpForm.controls['email'].value,
      otp: this.EmailDownloadCode,
      share_id: this.share_id
    }

    console.log('OTP JSON------------------->', jSon);
    this.apiService.checkOtpForUpload(jSon).subscribe((res: any) => {

      if (res.success == 1) {
        this.stopEmailOtpTimer();
        this.composeFormVisible = true;
        this.currentUserUid = res.userId;
      }
      else {
        this.EmailOtpWrongAttempts++;

        if (this.EmailOtpWrongAttempts >= this.maxEmailOtpAttempts) {
          this.isEmailOtpBlocked = true;
        } else {
          this.toast.showError(this.translateService.instant('invalid_code'), this.translateService.instant('error'));
        }
        // $('.checkOtp').html('Next');
        console.log(res);
      }
    }, (err: any) => {
      console.log(err);
    })
  }

  /** Reloads the page after the OTP attempt limit is reached. */
  reloadPage(): void {
    window.location.reload();
  }

  /** Starts (or restarts) the 5-minute countdown for the OTP's validity. */
  private startEmailOtpTimer(): void {
    this.emailOtpTimerSub?.unsubscribe();
    this.emailOtpExpired = false;
    this.emailOtpTimeLeft = this.emailOtpDurationSeconds;

    this.emailOtpTimerSub = interval(1000)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.emailOtpTimeLeft--;
        if (this.emailOtpTimeLeft <= 0) {
          this.emailOtpExpired = true;
          this.emailOtpTimerSub?.unsubscribe();
        }
      });
  }

  private stopEmailOtpTimer(): void {
    this.emailOtpTimerSub?.unsubscribe();
  }

  /** Formats the remaining OTP validity time as mm:ss. */
  get emailOtpTimeDisplay(): string {
    const minutes = Math.floor(this.emailOtpTimeLeft / 60);
    const seconds = this.emailOtpTimeLeft % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  getFreelancerDetails(jSon: any) {
    this.apiService.getFreelancerDetails(jSon).subscribe((res: any) => {
      console.log('REEeeeeeee', res);
      if (res.success == 0) {
        this.router.navigate(['/upload-link-expired'])
        this.titleService.setTitle('Transfer Center Download');
      }
      else if (res.success == 1) {
        this.currentUser = res.data;
        let loginUserID = {
          share_id: this.share_id
          // uid: this.currentUser.uid
        }
        this.getUserDetails(loginUserID);

        this.LogoUrl = this.currentUser.logo_url;
        this.companyName = this.currentUser.company_name;
        // Determine website URL based on user type and hyperlink value
        let websiteUrl: string;

        if (this.currentUser.company_website_hyperlink == null || this.currentUser.company_website_hyperlink == '') {
          // No custom URL provided - use default based on user type
          if (this.currentUser.is_master_user == 1 || this.currentUser.is_master_user == '1') {
            websiteUrl = "https://transfercenter.jp/business.html";
          } else {
            websiteUrl = "https://transfercenter.jp";
          }
        } else {
          // Custom URL provided - use it
          websiteUrl = this.currentUser.company_website_hyperlink;
        }

        // Ensure URL has proper protocol (http:// or https://)
        this.companyOwnWebsite = this.ensureUrlHasProtocol(websiteUrl);
        console.log('Current User ', JSON.stringify(this.currentUser));
        console.log('Is Master User:', this.currentUser.is_master_user);
        console.log('Company Website URL:', this.companyOwnWebsite);
        console.log('Current User ', JSON.stringify(this.currentUser));
        // console.log('organization name', this.currentUser.organization_name);
        if (this.currentUser.organization_name != '' || this.currentUser.organization_name != 'null' || this.currentUser.organization_name != null) {
          this.titleService.setTitle(this.currentUser.organization_name);
        }
        else {
          this.titleService.setTitle('Transfer Center Download');
        }

        if (this.currentUser.button_background_color != null && this.currentUser.button_background_color != 'null' && this.currentUser.button_background_color != '') {
          this.borderTopColor = '1px solid ' + this.currentUser.button_background_color;
          this.borderBottomColor = '1px solid ' + this.currentUser.button_background_color;
        }
        else {
          this.borderTopColor = '1px solid ' + this.buttonBGselectedColor;
          this.borderBottomColor = '1px solid ' + this.buttonBGselectedColor;
        }
      }

    }, (err: any) => {
      // console.log(err);
    })
  }

  getUserDetails(uid: any) {

    this.apiService.getUserDetails(uid).subscribe((res: any) => {
      if(res.success == 1){
      this.remainStorageCapacity = res.data.remaining_storage;
      }else{
        this.toast.showInfo(this.translateService.instant('unable_to_fetch_user_details'), this.translateService.instant('error'));
      }
    }, (err: any) => {
      console.log(err);
    })
  }

  parseNumber(value: any): number {
    return parseFloat(value);
  }

  ensureUrlHasProtocol(url: string): string {
    if (!url) {
      return "https://transfercenter.jp";
    }

    // Check if URL already has a protocol
    if (url.match(/^[a-zA-Z][a-zA-Z\d+\-.]*:/)) {
      return url;
    }

    // Add https:// if no protocol exists
    return 'https://' + url;
  }

  secondsToHms(d: any) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    // var hDisplay = h > 0 ? h + (h == 1 ? " hr , " : " hrs, ") : "";
    // var mDisplay = m > 0 ? m + (m == 1 ? " min , " : " mins, ") : "";
    // var sDisplay = s > 0 ? s + (s == 1 ? " sec" : " secs") : "";
    var hDisplay = h > 0 ? h + (h == 1 ? this.translateService.instant('hr') : this.translateService.instant('hrs')) : "";
    var mDisplay = m > 0 ? m + (m == 1 ? this.translateService.instant('min') : this.translateService.instant('mins')) : "";
    var sDisplay = s > 0 ? s + (s == 1 ? this.translateService.instant('sec') : this.translateService.instant('secs')) : "";
    return hDisplay + mDisplay + sDisplay;
  }

  fileTransferTime(file: any, timestamp: any, getIndex: any, uploadProgress: Observable<any>): void {

    uploadProgress.subscribe(progress => {
      // Run inside NgZone to ensure change detection is triggered
      this.ngZone.run(() => {
        // Calculate the uploaded size based on the progress percentage and the total file size
        const totalSize = file.size // Get the total size of the file (in bytes)
        const uploadedSize = Math.round((progress / 100) * totalSize);

        // Get the current upload speed (in bytes per second)
        const currentTime = new Date().getTime();
        const timeElapsed = (currentTime - timestamp) / 1000; // Convert to seconds
        const currentSpeed = (uploadedSize - 0) / timeElapsed; // Upload speed in bytes per second

        // Calculate the remaining size to upload
        const remainingSize = totalSize - uploadedSize;

        // Calculate the remaining time (in seconds)
        const remainingTimeInSeconds = remainingSize / currentSpeed;

        // Convert remaining time to a human-readable format (e.g., HH:mm:ss)
        const remainingTimeFormatted = this.secondsToHms(remainingTimeInSeconds);//formatRemainingTime(remainingTimeInSeconds);

        //this.remainingTime = remainingTimeFormatted;
        //this.InternetSpeed = currentSpeed;
        this.remainingTimes[getIndex] = remainingTimeFormatted;
        this.internetSpeed[getIndex] = currentSpeed;

        // Explicitly trigger change detection for smoother updates
        this.cdr.detectChanges();
      });
    });
  }

  getLocations() {
    let locationData = "";
    this.apiService.getGeoLocation(locationData).pipe(takeUntilDestroyed(this.destroyRef), detectChanges(this.cdr)).subscribe((locationDetails: any) => {
      console.log('locationDetails------------------>', locationDetails);

      // Extract IP address from MaxMind response
      this.ipaddress = locationDetails.ip ? locationDetails.ip : 'Unknown';

      // Extract location details from MaxMind response
      this.city = locationDetails.city ? locationDetails.city : 'Unknown';
      this.state = locationDetails.state ? locationDetails.state : 'Unknown';
      this.country = locationDetails.country ? locationDetails.country : 'Unknown';
      console.log(' Location:', this.ipaddress, this.city, this.state, this.country);
    })
  }


}
